import { resolveAntiBotMeta } from "../constants/antiBot";
import type { PageEntry } from "./pageEntry";
import type { SiteMetadata } from "./s3";
import type { SiteIdentity } from "./siteIdentity";

export const headerSiteProps = ({
  metadata,
  siteIdentity,
  pageEntry,
}: {
  metadata?: SiteMetadata | null;
  siteIdentity: SiteIdentity;
  pageEntry?: PageEntry | null;
}) => ({
  units: metadata?.units || [],
  unitGroupingMode: metadata?.unitGroupingMode,
  unitGroups: metadata?.unitGroups,
  unitGroupingLabel: metadata?.unitGroupingLabel,
  whatsappItems: metadata?.whatsapp?.items || [],
  whatsappButtonColor: metadata?.whatsapp?.buttonColor || "#25D366",
  whatsappSubmitUrl: metadata?.whatsapp?.endpointUrl || undefined,
  antiBot: resolveAntiBotMeta(metadata?.antiBot),
  accountId: siteIdentity.accountId,
  siteId: siteIdentity.siteId,
  product: pageEntry?.title,
  pageEntry,
});
